import React from 'react';
import ContactSection from '../components/ContactSection';

const Contact = () => {
  return (
    <div className="home-page">
      <ContactSection />
    </div>
  );
};

export default Contact;